import routes from '@configs/routes.json';
import { post } from './method';

export const accept = () => {
  return post(routes.api.termsOfService.accept);
};
